import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-routable.tsx
var LazyCourseRoutable = lazy(() => import("./course-routable-DEkFdDiD.js").then((n) => n.n).then((module) => ({ default: module.CourseRoutable })));
function CourseRoutable({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-routable" }),
		children: /* @__PURE__ */ jsx(LazyCourseRoutable, { ...props })
	});
}
var useCourseRoutable = () => {
	return useMemo(() => ({ course: { component: CourseRoutable } }), []);
};
//#endregion
export { useCourseRoutable };
